export default __webpack_public_path__ + "edc14235b528d9fe2107bd1dca66ed70.svg";